























import { Component, Vue, Prop } from 'vue-property-decorator';

import { Typography } from '@/components/atoms';
import BrowserControlsIcon from '@/components/icons/BrowserControls.vue';

import { WidgetDevice } from '@/models/Widget/settings';

@Component({
  components: {
    Typography,
    BrowserControlsIcon
  }
})
export default class DeviceMockup extends Vue {
  @Prop({ default: 'desktop' }) device?: WidgetDevice;
  @Prop({ default: '' }) website?: string;
  @Prop({ default: '' }) bgImage?: string;
  @Prop({ default: true }) showHeader?: boolean;
  @Prop({ default: false }) disabled?: boolean;

  get bgImageStyle() {
    if (!this.bgImage) return {};

    return {
      backgroundImage: `url(${this.bgImage})`
    };
  }
}
